import React from 'react';
import { states } from '@/constants/lifecycle';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import TabActions from '@/components/tabs/TabActions';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const CompleteActions = ({
  category,
  code,
  compact,
  goBack,
}) => {
  const {
    pollStatus, saveStatus, sourceUrl, subscriptionsReadStatus,
  } = Selectors.useCompleteActions({ category, code });
  const finishRequest = Events.useRemoveRequestSteps(category, { code });
  const cancelRequest = Events.useDestroyRequests();
  const items = { items: [{ code, isNew: true, steps: { sourceUrl } }], isArchival: false, silent: true };

  return (
    <TabActions className="aridhia-request-complete-actions">
      {(saveStatus === states.ERROR) && (
        <>
          <BackButton onClick={goBack} iconOnly={compact} />
          <CloseButton onClick={() => cancelRequest(items)} messageId="actions.close" />
        </>
      )}
      {(saveStatus !== states.ERROR) && (
        <CloseButton
          disabled={pollStatus === states.PENDING || [states.NONE, states.PENDING].includes(subscriptionsReadStatus)}
          messageId="actions.finish"
          onClick={finishRequest}
        />
      )}
    </TabActions>
  );
};

export default CompleteActions;
